import {THEME_CHANGE} from "./actionTypes";

export const themeChange = (theme) => {
    return {
        type: THEME_CHANGE,
        'payload':theme
    }
};